import { render, staticRenderFns } from "./dataWrap.vue?vue&type=template&id=3bac7746&scoped=true"
import script from "./dataWrap.vue?vue&type=script&lang=js"
export * from "./dataWrap.vue?vue&type=script&lang=js"
import style0 from "./dataWrap.vue?vue&type=style&index=0&id=3bac7746&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac7746",
  null
  
)

export default component.exports